





























import Vue from 'vue'
import { LOAD_EMPLOYEE_QCQ_QUALITY, INSERT_EMPLOYEE_QCQ_QUALITY } from '@/store/action-types'
import { EmployeeQcqQuality } from '@/model/employee/EmployeeQcqQuality'
import { EmployeeQualityPayload } from '@/types/payload'

interface ComponentData {
  isSaveButtonDisabled: boolean
  numberOfStars: number | null
  isStar1Disabled: boolean
  isStar2Disabled: boolean
  isStar3Disabled: boolean
  isStar4Disabled: boolean
  isStar5Disabled: boolean
  showSuccessSnackbar: boolean
  showErrorSnackbar: boolean
}

export default Vue.extend({
  name: 'QcqQuality',

  components: {},

  props: {
    employeeId: Number,
    stars: Number
  },

  data (): ComponentData {
    return {
      isSaveButtonDisabled: false,
      numberOfStars: null,
      isStar1Disabled: true,
      isStar2Disabled: true,
      isStar3Disabled: true,
      isStar4Disabled: true,
      isStar5Disabled: true,
      showSuccessSnackbar: false,
      showErrorSnackbar: false
    }
  },

  computed: {},

  watch: {
    employeeId (newVal: number): void {
      this.resetStars()

      if (newVal) {
        this.fetchQuality()
      }
    }
  },

  methods: {
    onResetButtonClick (): void {
      this.resetStars()
    },
    resetStars (): void {
      this.isStar1Disabled = true
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = null
    },
    star1 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 1
    },
    star2 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 2
    },
    star3 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 3
    },
    star4 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = true
      this.numberOfStars = 4
    },
    star5 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = false
      this.numberOfStars = 5
    },

    async onSaveButtonClick (): Promise<void> {
      this.isSaveButtonDisabled = true

      const payload: EmployeeQualityPayload = {
        employeeId: this.employeeId,
        numbersOfStars: this.numberOfStars
      }
      try {
        await this.$store.dispatch(INSERT_EMPLOYEE_QCQ_QUALITY, payload)
        this.isSaveButtonDisabled = false
        this.showSuccessSnackbar = true
        this.fetchQuality()
      } catch (e) {
        this.isSaveButtonDisabled = false
        this.showErrorSnackbar = true
      }

    },

    async fetchQuality (): Promise<void> {
      const payload: number = this.employeeId
      const data: EmployeeQcqQuality = await this.$store.dispatch(LOAD_EMPLOYEE_QCQ_QUALITY, payload)

      switch (data.numbersOfStars) {
        case null:
          this.resetStars()
          break
        case 1:
          this.star1()
          break
        case 2:
          this.star2()
          break
        case 3:
          this.star3()
          break
        case 4:
          this.star4()
          break
        case 5:
          this.star5()
          break
      }
    }
  },

  mounted (): void {
    this.fetchQuality()
  }

})
